import React from 'react';
import { Collapse, List, ListItem } from '@mui/material';

const ListItemNested = ({ children }) => (
  <ListItem
    button
    disableRipple
    sx={{
      padding: 0,

      '&:hover': {
        backgroundColor: 'transparent',
      },
    }}
  >
    {children}
  </ListItem>
);

const FilterComponent = ({ isOpen, children }) => (
  <Collapse in={isOpen} timeout="auto" unmountOnExit>
    <List component="div">
      <ListItemNested>{children}</ListItemNested>
    </List>
  </Collapse>
);

export default FilterComponent;
